/* *** nodes *** */

import { Viewport, XYPosition } from 'reactflow';
import { ExecutionNodeStatusEnum } from 'types';

// TODO Replace it with auto generated types from the backend
export type ConfigMapping = {
  /* file loaders */
  data_loader_workflow_execution: DataLoaderWorkflowExecutionConfiguration;
  data_loader_local_file: DataLoaderLocalFileConfiguration;
  data_loader_network_share: DataLoaderNetworkShareConfiguration;
  data_loader_archive_file: DataLoaderArchiveFileConfiguration;
  data_loader_one_drive: DataLoaderOneDriveConfiguration;
  data_loader_amazon_s3: DataLoaderAmazonS3Configuration;
  data_loader_azure_blob_storage: DataLoaderAzureBlobStorageConfiguration;
  data_loader_google_cloud_storage: DataLoaderGoogleCloudStorageConfiguration;
  data_loader_github_project: DataLoaderGitHubProjectConfiguration;
  data_loader_llm_research: LLMResearchConfiguration;
  /* llm */
  llm_extraction: LLMExtractionConfiguration;
  llm_prompt: LLMPromptConfiguration;
  llm_classify: LLMClassifyConfiguration;
  llm_summarize: LLMSummarizeConfiguration;
  llm_cluster: LLMClusterConfiguration;
  llm_count_tokens: LLMCountTokensConfiguration;
  legacy_llm_count_tokens: LegacyLLMCountTokensConfiguration;
  llm_map_reduce: LLMHierarchicalPromptConfiguration;
  llm_research: LLMResearchConfiguration;
  multimodal_gemini_prompt: MultimodalGeminiPromptConfiguration;
  plot_clustering: PlotClusteringConfiguration;
  coding_agent: CodingAgentConfiguration;
  /* data preprocessing */
  embedding: EmbeddingConfiguration;
  web_scraping: WebScrapingConfiguration;
  code_parser: CodeParserConfiguration;
  word_parser: WordParserConfiguration;
  /* data operations */
  keyword_matching: KeywordMatchingConfiguration;
  explode: ExplodeConfiguration;
  sampling_filter: SamplingFilterConfiguration;
  mapping: MappingConfiguration;
  regex_find: RegexFindConfiguration;
  simple_filter: SimpleFilterConfiguration;
  query_filter: QueryFilterConfiguration;
  drop_property: DropPropertyConfiguration;
  python_function: PythonFunctionConfiguration;
  default_value_column: DefaultValueColumnConfiguration;
  replace_text_shortcuts: ReplaceTextShortcutsConfiguration;
  remove_code_block_tags: RemoveCodeBlockTagsConfiguration;
  remove_code_comments: RemoveCodeCommentsConfiguration;
  rename_column: RenameColumnConfiguration;
  json_to_markdown: JSONToMarkdownConfiguration;
  /* flow control */
  merge: MergeConfiguration;
  embed_workflow: EmbedWorkflowConfiguration;
  loop_entry: LoopEntryConfiguration;
  loop_exit: LoopExitConfiguration;
  loop_workflow: LoopWorkflowConfiguration;
  /* validation */
  llm_extraction_validation: LLMExtractionValidationConfiguration;
  keyword_matching_validation: KeywordMatchingValidationConfiguration;
  /* file export */
  report_generate: ReportGeneratorConfiguration;
  data_export_file: DataExportFileConfiguration;
  data_export_archive: DataExportArchiveConfiguration;
  data_export_website: DataExportWebsiteConfiguration;
  visualize_diagram: VisualizeDiagramConfiguration;
  github_wiki_page_upload: GitHubWikiPageUploadConfiguration;
  group_merge: GroupMergeConfiguration;
  git_export: GitExportConfiguration;
  default: {};
  proxy: {};
};
export type WorkflowNodeType = keyof ConfigMapping;
export type WorkflowNodeConfiguration = ConfigMapping[WorkflowNodeType];

/* data loaders */
export type DataLoaderWorkflowExecutionConfiguration = {
  workflow_id: string;
  execution_id: string;
  node_id: string;
};

export type DataLoaderLocalFileConfiguration = {
  file_path: string;
  file_type: string;
  delimiter?: string;
};

export type SoftwareProjectExtractorSettings = {
  include_text_content: boolean;
  include_binary_content: boolean;
};

export type TabDataExtractorSettings = {
  separator?: string;
};

export type ExtractorSettings = SoftwareProjectExtractorSettings | TabDataExtractorSettings;

export type DataLoaderArchiveFileConfiguration = {
  file_path: string;
  extractor_type: string;
  extractor_settings?: ExtractorSettings;
};

export type DataLoaderNetworkShareConfiguration = {};
export type DataLoaderOneDriveConfiguration = {};
export type DataLoaderAmazonS3Configuration = {};
export type DataLoaderAzureBlobStorageConfiguration = {};
export type DataLoaderGoogleCloudStorageConfiguration = {};

type GitCommonConfiguration = {
  repo_url: string;
  secret_id: string | null;
};

export type DataLoaderGitHubProjectConfiguration = GitCommonConfiguration & {
  branch: string | null;
  subdirectory: string | null;
  extractor_settings?: SoftwareProjectExtractorSettings;
};

/* llm */
type ParallelProcessingConfiguration = {
  threads: number;
};

export type LLMCommonConfiguration = {
  model_id: string;
  prompt_id: string;
  prompt_revision?: number;
  temperature?: number;
  log_prompts?: boolean;
};

type LLMFallbackModelConfiguration = {
  fallback_model_id?: string;
  fallback_token_threshold?: number;
};

type TextOperator =
  | '='
  | '!='
  | 'CONTAINS'
  | 'NOT CONTAINS'
  | 'STARTS WITH'
  | 'ENDS WITH'
  | 'CONTAINS WORD'
  | 'NOT CONTAINS WORD'
  | 'STARTS WITH WORD'
  | 'ENDS WITH WORD';

type LLMEvaluationConfiguration = {
  evaluation_model_id?: string;
  evaluation_prompt_id?: string;
  evaluation_prompt_revision?: number;
  evaluation_operator?: TextOperator;
  evaluation_expected_value?: string;
  evaluation_max_retries?: number;
};

export type LLMExtractionConfiguration = LLMCommonConfiguration & {
  column_name: string;
  extraction_schema: LLMExtractionSchema;
};

export type LLMExtractionSchema = {
  properties: Record<string, LLMExtractionSchemaProperty>;
  required: string[];
};

export type LLMExtractionSchemaProperty = {
  type: string;
  description: string;
  enum?: string[];
  items?: { type: string };
};

export type MultimodalGeminiPromptConfiguration = {
  column_name: string;
  project_id: string;
  result_column: string;
  prompt: string;
  model_name: string;
  mime_type: string;
  location: string;
};

export type LLMClassifyConfiguration = LLMCommonConfiguration & {
  column_name: string;
  classify_schema: LLMClassifySchema;
};

export type LLMClassifySchema = {
  properties: Record<string, LLMClassifySchemaProperty>;
  required: string[];
};

export type LLMClassifySchemaProperty = {
  field_key: string;
  type: string;
  description: string;
  classes: string[];
};

// used to proxy results
export type LLMExtractionSchemaPropertyTemp = {
  field_key: string;
  type: string;
  description: string;
  required: boolean;
  is_enum?: boolean;
  enum?: string[];
  array_items_type?: string;
};

export type LLMPromptConfiguration = LLMCommonConfiguration &
  LLMFallbackModelConfiguration &
  LLMEvaluationConfiguration &
  ParallelProcessingConfiguration & {
    input_data?: Record<string, string>;
    output_column?: string;
    multimodal_file_content_column?: string;
    multimodal_file_type_column?: string;
    multimodal_file_type?: string;
    expand_multimodal_settings?: boolean;
    expand_evaluation_settings?: boolean;
  };

export type LLMSummarizeSchemaProperty = {
  column_name: string;
  type: string;
  description: string;
  word_count: number;
};

export type LLMSummarizeSchema = {
  properties: Record<string, LLMSummarizeSchemaProperty>;
  required: string[];
};

export type LLMSummarizeConfiguration = LLMCommonConfiguration & {
  column_name: string;
  summarize_schema: LLMSummarizeSchema;
};

export type LLMCountTokensConfiguration = ParallelProcessingConfiguration & {
  column_name: string;
  model_id: string;
};

export type LegacyLLMCountTokensConfiguration = {
  column_name: string;
  strategy: string;
  model_name?: string;
  location?: string;
  project_id?: string;
  anthropic_model?: string;
};

export type LLMClusterConfiguration = {
  column_name: string;
  max_clusters?: number;
  random_state?: number;
};

export enum HierarchicalPromptMode {
  BOTTOM_UP = 'bottom_up',
  TOP_DOWN = 'top_down',
}

export type LLMHierarchicalPromptConfiguration = LLMCommonConfiguration &
  LLMFallbackModelConfiguration & {
    column_name: string;
    identifier_column: string;
    result_column: string;
    dependencies_column: string;
    mode: HierarchicalPromptMode;
    input_data?: Record<string, string>;
  };

type PerplexityUserLocationOptions = {
  city?: string;
  region?: string;
  country?: string;
  latitude?: number;
  longitude?: number;
};

type PerplexityWebSearchOptions = {
  search_context_size?: 'low' | 'medium' | 'high';
  user_location?: PerplexityUserLocationOptions;
  image_search_relevance_enhanced?: boolean;
};

type PerplexityOptions = {
  search_mode?: 'web' | 'academic';
  reasoning_effort?: 'low' | 'medium' | 'high';
  return_images?: boolean;
  return_related_questions?: boolean;
  search_domain_filter?: string[];
  search_recency_filter?: 'day' | 'week' | 'month' | 'year';
  search_after_date_filter?: string;
  search_before_date_filter?: string;
  last_updated_after_filter?: string;
  last_updated_before_filter?: string;
  disable_search?: boolean;
  enable_search_classifier?: boolean;
  web_search_options?: PerplexityWebSearchOptions;
};

export type LLMResearchConfiguration = LLMCommonConfiguration & {
  result_column: string;
  search_results_column?: string;
  thinking_results_column?: string;
  input_data: Record<string, string>;
  options: PerplexityOptions;
};

export type PlotClusteringConfiguration = {
  column_name: string;
};

export enum CodingAgentType {
  CODEX = 'codex',
  CLAUDE = 'claude',
  OPENCODE = 'opencode',
}

export enum CodingAgentTool {
  FILE_READ = 'file_read',
  FILE_EDIT = 'file_edit',
  SHELL = 'shell',
  WEB_ACCESS = 'web_access',
  SUBAGENTS = 'subagents',
}

export enum ToolControlMode {
  ALLOW_ALL = 'allow_all',
  ALLOWLIST = 'allowlist',
  DENYLIST = 'denylist',
}

export type CodingAgentToolControl = {
  mode: ToolControlMode;
  tools?: CodingAgentTool[];
};

export enum McpTransport {
  HTTP = 'http',
  SSE = 'sse',
}

export type CodingAgentMcpServer = {
  name: string;
  transport: McpTransport;
  url: string;
  headers: Record<string, string>;
};

type CodingAgentEvaluationConfiguration = {
  evaluation_model_id?: string;
  evaluation_prompt_id?: string;
  evaluation_prompt_revision?: number;
  evaluation_operator?: TextOperator;
  evaluation_expected_value?: string;
};

export type CodingAgentConfiguration = CodingAgentEvaluationConfiguration & {
  agent_type: CodingAgentType;
  model_id?: string;
  prompt_id: string;
  prompt_revision: number;
  secret_id?: string;
  file_name_column: string;
  file_path_column: string;
  file_content_column: string;
  binary: boolean;
  tool_control?: CodingAgentToolControl;
  mcp_servers?: CodingAgentMcpServer[];
  expand_evaluation_settings?: boolean;
};

export type RemoveCodeBlockTagsConfiguration = {
  column_name: string;
};

/* data preprocessing */
export type EmbeddingConfiguration = {
  column_name: string;
  model_id: string;
  embedding_size: number;
  fake?: boolean;
};

export type CodeParserConfiguration = {};
export type WordParserConfiguration = {
  column_name: string;
  extension: string;
};

export type WebScrapingConfiguration = {
  column_name: string;
  result_column: string;
  raw?: boolean;
};

/* data operations */
export type KeywordMatchingConfiguration = {
  column_name: string;
  keyword_label_map?: Record<string, string[]>;
  keyword_label_map_file_path?: string;
  result_column: string;
  case_sensitive: boolean;
};

export type ExplodeConfiguration = {
  column_name: string;
  data_format: string;
  explode_target: string;
  properties_to_explode: string;
  properties_column_name?: string;
  properties?: string[];
};

export type SamplingFilterConfiguration = {
  sample_strategy: string;
  sample_size?: number;
  range_start?: number;
  range_end?: number;
};

export type MappingConfiguration = {
  column_name: string;
  map_dict?: Record<string, string>;
  map_file_path?: string;
  result_column: string;
  case_sensitive: boolean;
  regex?: boolean;
};

export type RegexFindConfiguration = {
  column_name: string;
  regex_pattern: string;
  mode: string;
  result_column: string;
};

export type Operator =
  | '='
  | '!='
  | '>'
  | '<'
  | '>='
  | '<='
  | 'CONTAINS'
  | 'NOT CONTAINS'
  | 'STARTS WITH'
  | 'ENDS WITH'
  | 'IN'
  | 'NOT IN'
  | 'IS NULL'
  | 'IS NOT NULL';

export type Condition = {
  column_name: string;
  operator: Operator;
  filter_value?: string | null;
  in_values?: string[];
};

export type ConditionGroup = {
  operator: 'AND' | 'OR';
  conditions: Condition[];
  groups: ConditionGroup[];
};

export type SimpleFilterConfiguration = Condition;

export type QueryFilterConfiguration = {
  condition_group: ConditionGroup;
};

export type GroupMergeConfiguration = {
  columns_to_include: string[];
  grouping_column?: string;
  template?: string;
  grouping_col_condition?: string;
  process_arrays?: boolean;
};

export type DropPropertyConfiguration = {
  column_names: string[];
};

export type PythonFunctionConfiguration = {
  function_id: string;
  function_revision?: number;
  node_order?: string[];
};

type ColumnType = 'string' | 'integer' | 'float' | 'boolean';

export type DefaultValueColumnConfiguration = {
  column_name: string;
  column_type: ColumnType;
  value?: string | number | boolean | null;
};

export type ReplaceTextShortcutsConfiguration = {
  column_name: string;
  shortcuts_dict?: Record<string, string>;
  shortcuts_file_path?: string;
};

export type RemoveCodeCommentsConfiguration = {
  code_column: string;
  extension_column: string;
  trim_newlines: boolean;
};

export type RenameColumnItem = {
  old_name: string;
  new_name: string;
};

export type RenameColumnConfiguration = {
  columns: RenameColumnItem[];
};

export type JSONToMarkdownConfiguration = {
  column_name: string;
  result_column: string;
};

/* flow control */
export type JoinConfiguration = {
  node_id: string;
  column: string;
};

export type MergeConfiguration = {
  strategy: 'union' | 'intersect' | 'join';
  join_order: JoinConfiguration[] | null;
  join_type: 'INNER' | 'LEFT' | 'RIGHT' | 'FULL OUTER';
};

export type SubworkflowCommonConfiguration = {
  workflow_id: string;
  revision?: number;
};

export type EmbedWorkflowConnection = {
  parent_node_id: string;
  child_node_id: string;
};

export type EmbedWorkflowConfiguration = SubworkflowCommonConfiguration & {
  input_node_mappings: EmbedWorkflowConnection[];
  output_node_mappings: EmbedWorkflowConnection[];
};

export type LoopEntryConfiguration = {};

export type LoopExitConfiguration = {
  condition: string;
};

export type LoopWorkflowConfiguration = SubworkflowCommonConfiguration & {
  max_iterations?: number;
};

/* validation */
export type LLMExtractionValidationConfiguration = {
  content_column_name: string;
  validation_target_column_name: string;
  result_column: string;
};

export type KeywordMatchingValidationConfiguration = LLMCommonConfiguration & {
  content_column_name: string;
  validation_target_column_name: string;
  result_column: string;
  keyword_category_definitions?: Record<string, string>;
  keyword_category_definitions_file_path?: string;
};

/* data export */
export type ReportGeneratorConfiguration = {
  source_files?: string;
  source_methods?: string;
  source_folders?: string;
  source_data?: string;
  yaml: string;
  export_format?: 'html' | 'markdown';
};

export type DataExportFileConfiguration = {
  file_type: string;
};

export type DataExportArchiveConfiguration = {
  file_name_column: string;
  file_path_column?: string;
  file_content_column: string;
  extension_column?: string;
  binary: boolean;
};

export type DataExportWebsiteConfiguration = {
  column_name: string;
  file_name?: string;
};

export type VisualizeDiagramConfiguration = {
  column_name: string;
  image_type: string;
  export_file_column?: string;
  export_rows_separately?: boolean;
};

export type GitHubWikiPageUploadConfiguration = GitCommonConfiguration & {
  secret_id: string;
  page_name_column: string;
  page_content_column: string;
  git_user_name?: string | null;
  git_user_email?: string | null;
};

export type GitExportConfiguration = GitCommonConfiguration & {
  secret_id: string;
  file_name_column: string;
  file_path_column: string;
  file_content_column: string;
  binary: boolean;
  branch?: string | null;
  generate_unique_branch: boolean;
  base_branch?: string | null;
  generate_commit_message: boolean;
  commit_message?: string | null;
  git_user_name?: string | null;
  git_user_email?: string | null;
};

/* *** workflow *** */

export type WorkflowStatus = 'DRAFT' | 'PUBLISHED';

export type WorkflowParameter = {
  name: string;
  default_value: string | null;
  description: string;
};

export type WorkflowSummary = {
  id: string;
  revision: number;
  project_id: string;
  status: WorkflowStatus;
  name: string;
  description: string;
  created_at?: string;
  data_protected: boolean;
  data_protection_updated_at: string;
  parameters: WorkflowParameter[];
};

export type Workflow = WorkflowSummary & {
  nodes: WorkflowNode[];
  edges: WorkflowEdge[];
  viewport_metadata?: WorkflowMetadata;
};

export type BatchDeleteWorkflowsRequest = {
  workflow_ids: string[];
};

export type BatchDeleteWorkflowFailure = {
  workflow_id: string;
  detail: string;
};

export type BatchDeleteWorkflowsResponse = {
  deleted_workflow_ids: string[];
  failures: BatchDeleteWorkflowFailure[];
};

export type WorkflowExecutionStatus = 'FAILED' | 'COMPLETED' | 'RUNNING' | 'CANCELLED';

export type WorkflowExecutionSummary = {
  id: string;
  project_id: string;
  workflow_id: string;
  workflow_revision: number;
  workflow_name: string;
  dispatch_id: string;
  trigger_time: string;
  end_time: string | null;
  duration: number | null;
  status: WorkflowExecutionStatus;
  test_mode: boolean;
  parameters: Record<string, string>;
  cleaned_up: boolean;
  archived_at: string | null;
  parent_execution_id?: string | null;
};

type WorkflowExecutionNodeResult = {
  node_id: string;
  export_file_id: string | string[];
};

export type WorkflowExecution = WorkflowExecutionSummary & {
  progress: number;
  token_usage?: TokenUsageMetadata;
  results: WorkflowExecutionNodeResult[];
};

export type WorkflowExecutionFull = WorkflowExecution & {
  node_progress: WorkflowExecutionNode[];
};

export type NodeResult = {
  project_id: string;
  execution_id: string;
  node_id: string;
  tables?: { step: string; table: string }[];
  subworkflow_input_data?: SubworkflowInputData;
  subworkflow_output_data?: SubworkflowOutputData;
  export_file_id?: string | string[];
  log_file_id?: string;
  token_usage_metadata?: TokenUsageMetadata;
  node_token_usage_metadata?: TokenUsageMetadata;
  metadata?: object;
  validation_error?: string;
  warnings?: string[];
};

export type WorkflowExecutionNode = {
  node_id: string;
  execution_id: string;
  status: ExecutionNodeStatusEnum;
  trigger_time: string;
  end_time: string;
  duration: number;
  items_count: number;
  processed_items_count: number;
  processed_items_percent: number;
  log_revision?: number;
  result?: NodeResult;
  test_mode: boolean;
};

export type CellValue = string | number | boolean | null;

export type NodeOutputData = Record<string, CellValue>;

export type NodeOutputDetailsResponse = {
  data: NodeOutputData[];
  total: number;
};

export type WorkflowMetadata = {
  viewport: Viewport;
};

export enum TestDataType {
  DATAFRAME = 'dataframe',
  FILE = 'file',
  NEW_COLUMN = 'new_column',
  LATEST_RESULT = 'latest_result',
}

export type TestDataValue = CellValue;
export type TestDataColumn = (string | null)[] | (number | null)[] | (boolean | null)[];
export type TestDataFrame = Record<string, TestDataColumn>;
export type TestDataFile = DataLoaderLocalFileConfiguration;

export type WorkflowNodeTestData = {
  type: TestDataType;
  column?: string;
  append?: boolean;
  data?: TestDataFrame | TestDataFile | TestDataValue;
};

export type WorkflowNodeExpectedColumns = {
  input_columns: string[];
  output_columns: string[];
  removed_columns: string[];
  replaces_dataframe?: boolean;
};

export type WorkflowNode = {
  id: string;
  workflow_id: string;
  workflow_revision: number;
  name: string;
  type: WorkflowNodeType;
  description: string;
  enabled: boolean;
  configuration: WorkflowNodeConfiguration;
  viewport_metadata?: WorkflowNodeMetadata;
  test_data?: WorkflowNodeTestData;
  expected_columns?: WorkflowNodeExpectedColumns;
};

export type WorkflowNodeMetadata = {
  position: XYPosition;
};

export type WorkflowEdge = {
  source: string;
  target: string;
  id?: string;
  workflow_id: string;
  workflow_revision: number;
};

export type CreateWorkflowRequest = {
  id?: string;
  revision?: number;
  name: string;
  description?: string;
  status?: WorkflowStatus;
  nodes?: CreateWorkflowNode[];
  edges?: WorkflowEdge[];
  viewport_metadata?: WorkflowMetadata;
  parameters?: WorkflowParameter[];
};

export type UpdateWorkflowMetadataRequest = {
  name: string;
  description: string;
  project_id: string;
};

export type UpdateWorkflowDataProtectionRequest = {
  data_protected: boolean;
};

export type CreateWorkflowNode = {
  id: string;
  name: string;
  type: WorkflowNodeType;
  description?: string;
  enabled: boolean;
  configuration?: WorkflowNodeConfiguration;
  viewport_metadata?: WorkflowNodeMetadata;
  test_data?: WorkflowNodeTestData;
};

export type CreateEmbedWorkflowNode = {
  id: string;
  name: string;
  type: WorkflowNodeType;
  description?: string;
  enabled: boolean;
  configuration?: EmbedWorkflowConfiguration;
  viewport_metadata?: WorkflowNodeMetadata;
};

export type UpdateWorkflowStep = {
  id: string;
  workflow_id?: string;
  workflow_revision?: number;
  position?: number;
  name?: string;
  type?: WorkflowNodeType;
  description?: string;
  enabled?: boolean;
  configuration?: WorkflowNodeConfiguration;
};

export type SubworkflowInputData = {
  parent_execution_id: string;
};

export type SubworkflowOutputData = {
  child_execution_id: string;
  child_workflow_id: string;
  child_workflow_revision: number;
};

export type CostEstimationMapping = Record<string, number>;

export type NodeEstimate = {
  node_id: string;
  node_type: string;
  node_name: string;
  input_row_count: number;
  input_token_count: number;
  output_token_count: number;
  cost: number;
};

export type CostEstimate = {
  workflow_id: string;
  total_cost: number;
  currency: 'USD';
  breakdown: NodeEstimate[];
  generated_time: string;
};

export type NodeValidationResult = {
  valid: boolean;
  errors: string[];
};

export type EmbedWorkflowNodeValidationData = {
  edges: WorkflowEdge[];
};

export type NodeValidationExtraData = EmbedWorkflowNodeValidationData | null;

export type WorkflowNodeRevisionMappingResponse = {
  mapping: Record<string, WorkflowNode | null>;
};

export type WorkflowPromptNodeUsage = {
  executions: WorkflowExecutionSummary[];
  completed_nodes: Record<string, WorkflowNode[]>;
};

export type PythonFunctionTestRunRequest = {
  function_code: string;
  input_count: number;
  extra_libs?: string[];
  parameters?: Record<string, string>;
};

export type PythonFunctionTestRunResponse = {
  success: boolean;
  logs: string[];
  error: string | null;
  error_traceback: string | null;
};

/* *** batch jobs *** */

export type BatchJob = {
  id: string;
  project_id: string;
  name: string;
  description?: string;
  workflow_id: string;
  input_files: Record<string, string>[];
};

export type CreateBatchJobRequest = {
  name: string;
  description?: string;
  workflow_id: string;
  input_files: Record<string, string>[];
};

export type BatchJobFormData = {
  name: string;
  description?: string;
  workflow_name: string;
  input_files: Record<string, string>[];
};

export type BatchJobExecutionStatus = 'RUNNING' | 'COMPLETED' | 'COMPLETED_WITH_ERRORS' | 'FAILED';

export type BatchJobExecution = {
  id: string;
  batch_job_id: string;
  project_id: string;
  status: BatchJobExecutionStatus;
  trigger_time: string;
  num_iterations?: number;
};

export interface BatchJobIteration {
  id: string;
  batch_job_execution_id: string;
  workflow_execution_id: string;
  input_files_mapping: Record<string, string>;
  status: string;
  trigger_time: string;
}

/* *** prompts models *** */

export enum ModelType {
  OPEN_AI = 'openai',
  ANTHROPIC = 'anthropic',
  GOOGLE = 'google',
  VERTEX = 'vertex',
  BEDROCK = 'bedrock',
  PERPLEXITY = 'perplexity',
  XAI = 'xai',
  OLLAMA = 'ollama',
}

export const MODEL_TYPES = [...Object.values(ModelType)];

export type CreatePromptModelRequest = {
  name: string;
  description?: string;
  type: ModelType;
  secret_id?: string | null;
  is_local?: boolean;
  settings: ProviderSettings | null;
};

/* eslint-disable @typescript-eslint/no-duplicate-type-constituents */
export type ProviderSettings =
  | OpenAISettings
  | AnthropicSettings
  | GoogleSettings
  | VertexAISettings
  | BedrockSettings
  | PerplexitySettings
  | XAISettings
  | OllamaSettings;

type BaseProviderSettings = {
  model: string;
  max_tokens?: number | null;
};

export type SafetySettings = {
  harassment?: number;
  hate_speech?: number;
  sexually_explicit?: number;
  dangerous_content?: number;
};

export type OpenAISettings = BaseProviderSettings & {
  openai_api_base?: string | null;
  openai_proxy?: string | null;
};

export type AnthropicSettings = BaseProviderSettings;

export type GoogleSettings = BaseProviderSettings & {
  safety_settings?: SafetySettings | null;
};

export type VertexAISettings = BaseProviderSettings & {
  project_id: string;
  location: string;
  safety_settings?: SafetySettings | null;
};

export type BedrockSettings = BaseProviderSettings;

export type PerplexitySettings = BaseProviderSettings;

export type XAISettings = BaseProviderSettings;

export type OllamaSettings = BaseProviderSettings & {
  base_url: string;
};

export type CreateLLMModelSpecificationRequest = {
  name: string;
  provider: ModelType;
  group: string;
  description?: string;
  specification_name?: string;
  fetch_specification?: boolean;
};

export type LLMModelSpecification = {
  name: string;
  provider: ModelType;
  group: string;
  group_order: number;
  model_order: number;
  description: string;
  specification_name?: string;
  fetch_specification?: boolean;
  max_input_tokens?: number;
  max_output_tokens?: number;
  input_cost_per_token?: number;
  output_cost_per_token?: number;
  cache_read_input_cost_per_token?: number;
  image_input?: boolean;
  video_input?: boolean;
  audio_input?: boolean;
  pdf_input?: boolean;
};

export type LLMModelSpecificationGroupReorderRequest = {
  group: string;
  models: string[];
};

export type LLMModelSpecificationReorderRequest = {
  groups: LLMModelSpecificationGroupReorderRequest[];
};

export type PromptModel = {
  id: string;
  created_at: string;
  owner_id: string;
  name: string;
  type: ModelType;
  description?: string;
  is_local?: boolean;
  settings: ProviderSettings | null;
};

/* *** prompts *** */

export type CreatePromptRequest = {
  prompt_name: string;
  description: string;
  type: string;
  template: string;
  inputs: string[];
  examples: PromptExample[];
  project_id: string | null;
  folder_path?: string | null;
};

export type PromptExample = {
  example_inputs: object;
  output: string;
};

export type Prompt = {
  id: string;
  revision: number;
  project_id: string | null;
  prompt_name: string;
  description: string;
  type: string;
  template: string;
  inputs: string[];
  examples: PromptExample[];
  created_at: string;
  is_default: true;
  folder_path?: string | null;
};

/* *** python functions *** */

export type CreatePythonFunctionRequest = {
  name: string;
  description: string;
  function_code: string;
  extra_libs?: string[];
  project_id: string | null;
  folder_path?: string | null;
};

export type UpdatePythonFunctionRequest = CreatePythonFunctionRequest & {
  revision: number;
};

export type PythonFunctionSummary = {
  id: string;
  revision: number;
  project_id: string | null;
  name: string;
  description: string;
  folder_path?: string | null;
  extra_libs: string[];
  created_at: string;
};

export type PythonFunction = PythonFunctionSummary & {
  function_code: string;
};

/* *** prompts test case *** */

export type PromptTestCase = {
  id: string;
  prompt_id: string;
  prompt_revision: number;
  llm_model_id: string;
  test_case: object;
  temperature?: number;
};

export type PromptTestCaseRequest = {
  llm_model_id: string;
  test_case: object;
  temperature?: number;
};

export type PromptTestCaseRunRequest = {
  run_count?: number;
};

export type TokenUsageMetadata = {
  total_tokens: number;
  prompt_tokens: number;
  cached_prompt_tokens?: number;
  completion_tokens: number;
  total_cost: number;
};

export type FillLLMTestDataResponse = {
  workflow: Workflow;
  updated_nodes_count: number;
  failed_nodes_count: number;
  token_usage: TokenUsageMetadata;
};

export type PromptTestCaseResult = {
  test_case_id: string;
  prompt_template: string;
  response: string;
  token_usage_metadata: TokenUsageMetadata;
};

export type PromptTestCaseRun = {
  id: string;
  test_case_id: string;
  prompt_id: string;
  prompt_revision: number;
  llm_model_id: string;
  test_case: object;
  prompt_template: string;
  response: string;
  token_usage_metadata: TokenUsageMetadata;
  created_at: string;
};

export type PromptTestCasePreview = {
  compiled_prompt: string;
  token_count: number;
};

/* *** file management *** */

export type FileManagement = {
  id: string;
  project_id?: string;
  owner_id: string;
  file_name: string;
  file_size: number;
  file_key: string;
  mime_type: string;
  created_at: string;
  meta?: FileManagementMeta;
};

export type FileManagementMeta = {
  content?: FileManagementMetaContent[];
  validation_result?: FileManagementMetaValidationResult;
};

export type FileManagementMetaContent = {
  columns?: string[];
};

export type FileManagementMetaValidationResult = {
  valid: boolean;
  errors: FileManagementMetaValidationError[];
};

export type FileManagementMetaValidationError = {
  row_number?: number;
  error_type: string;
};

export type FileManagementRequest = {
  file: string;
  isGlobal?: boolean;
};

export type FileSignedDownloadUrl = {
  file_id: string;
  expiry_date: string;
  url: string;
};

/* *** projects *** */

export type CreateProjectRequest = {
  name: string;
  description: string;
};

export enum CloneDependencyStrategy {
  ALL = 'all',
  USED = 'used',
  NONE = 'none',
}

export type ProjectCloneDependenciesRequest = {
  files: CloneDependencyStrategy;
  prompts: CloneDependencyStrategy;
  python_functions: CloneDependencyStrategy;
  secrets: CloneDependencyStrategy;
  executions: CloneDependencyStrategy;
};

export type ProjectCloneRequest = {
  name: string;
  description: string;
  dependencies: ProjectCloneDependenciesRequest;
};

export type ProjectCloneResponse = {
  project_id: string;
  workflows_cloned: number;
  workflow_revisions_cloned: number;
  prompts_cloned: number;
  prompt_revisions_cloned: number;
  python_functions_cloned: number;
  python_function_revisions_cloned: number;
  secrets_cloned: number;
  files_cloned: number;
  executions_cloned: number;
};

export type Project = {
  id: string;
  name: string;
  description: string;
  is_default: boolean;
};

export type RevisedWorkflow = {
  workflow_id: string;
  revision: number;
};

/* *** secrets *** */

export type SecretType = 'api_key' | 'git_auth' | 'coding_agent_credentials';

type SecretBase = {
  name: string;
  type: SecretType;
  description: string;
  project_id: string | null;
};

export type CreateSecretRequest = SecretBase & {
  value: string;
};

export type UpdateSecretRequest = SecretBase;

export type Secret = SecretBase & {
  id: string;
  value: string;
};

export type UpdateSecretValueRequest = {
  value: string;
};

/* *** auth & users *** */

export type UserPublic = {
  id: string;
  username: string;
  display_name: string;
  is_active: boolean;
  is_superuser: boolean;
  created_at: string;
  last_login_at: string | null;
};

export type TokenPair = {
  access_token: string;
  refresh_token: string;
  token_type: string;
};

export type LoginRequest = {
  username: string;
  password: string;
};

export type RegisterUserRequest = {
  username: string;
  password: string;
  display_name?: string;
  is_superuser?: boolean;
};

export type UpdateProfileRequest = {
  display_name: string;
};

export type ChangePasswordRequest = {
  current_password: string;
  new_password: string;
};

export type UserSortField = keyof UserPublic;

export type UserFilterOperator = 'eq' | 'neq' | 'gt' | 'gte' | 'lt' | 'lte' | 'like' | 'ilike';

export type UserFilter = {
  field: UserSortField;
  operator: UserFilterOperator;
  value: string;
};

export type UsersPageParams = {
  page: number;
  pageSize: number;
  sort?: string[];
  filters?: UserFilter[];
};

/* *** recent workflows & live executions *** */

export type RecentWorkflowSort = 'last_activity' | 'last_opened' | 'last_executed' | 'last_modified' | 'created_at';

export type RecentWorkflow = Workflow & {
  owner_id: string | null;
  last_activity_at: string;
  last_opened_at: string | null;
  last_executed_at: string | null;
  last_modified_at: string | null;
};

export type RecentWorkflowsParams = {
  page: number;
  pageSize: number;
  sort?: RecentWorkflowSort;
  onlyOwned?: boolean;
  projectId?: string;
};

export type ActivityAction = 'opened';

export type RecordActivityRequest = {
  entity_id: string;
  action: ActivityAction;
  entity_type?: 'workflow';
  project_id?: string;
};

export type VersionMetadata = {
  version: string | null;
  branch: string | null;
  commit_hash: string | null;
  build_date: string | null;
};

export enum QueryKey {
  Workflows = 'workflows',
  WorkflowLLMNodes = 'workflow-llm-nodes',
  RevisedWorkflows = 'revised-workflows',
  WorkflowExecutions = 'workflow-executions',
  WorkflowExecutionsInfinite = 'workflow-executions-infinite',
  WorkflowExecutionNodes = 'workflow-execution-nodes',
  WorkflowExecutionNodeStatus = 'workflow-execution-node-status',
  WorkflowExecutionNodeLogs = 'workflow-execution-node-logs',
  WorkflowExecutionData = 'workflow-execution-data',
  NodeOutputData = 'node-output-data',
  Prompts = 'prompts',
  PromptFolders = 'prompt-folders',
  PromptTestCases = 'prompt-test-cases',
  PromptModels = 'prompt-models',
  PromptUsage = 'prompt-usage',
  PythonFunctions = 'python-functions',
  PythonFunctionFolders = 'python-function-folders',
  PythonFunctionUsage = 'python-function-usage',
  ModelSpecifications = 'model-specifications',
  Projects = 'projects',
  FileManagement = 'file-management',
  BatchJobs = 'batch-jobs',
  BatchJobExecutions = 'batch-job-executions',
  BatchJobIterations = 'batch-job-iterations',
  Secrets = 'secrets',
  SecretUsage = 'secret-usage',
  Version = 'version',
  CurrentUser = 'current-user',
  Users = 'users',
  RecentWorkflows = 'recent-workflows',
  LiveExecutions = 'live-executions',
}

export type ApiErrorResponse = {
  detail: string;
};

export type ApiValidationErrorResponse = {
  detail: {
    errors: string[];
  };
};

export type ApiErrorDetail = {
  msg: string;
  loc: (string | number)[];
};

export type UnprocessableEntityErrorResponse = {
  detail: ApiErrorDetail[];
};
